import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import Employees from './Employees';

const EmployeeList = () => {
  return renderComponent(<Employees />);
};

export default EmployeeList;
